// core
import React from "react";

// components
import QuoteTablePanel from "./QuoteTablePanel/QuoteTablePanel";

// interfaces
import { QuoteTableInfo } from "../../../types/quoteTable/QuoteTableInfo";
import QuoteTableSection from "./QuoteTableSection";
interface IQuoteTableProps {
    model: QuoteTableInfo;
}

// rendering
const QuoteTable: React.FC<IQuoteTableProps> = (props) => {
    const { model } = props;

    const hasMultipleCollectiveSections =
        model.sections.filter((s) => s.type === "collective").length > 1;

    return (
        <React.Fragment>
            {model.sections.map((section, index) => {
                const isLastSection =
                    index + 1 === model.sections.length ||
                    model.sections[index + 1]?.type === "collective";

                if (section.type === "standalone") {
                    return (
                        <QuoteTableSection
                            key={section.id}
                            sectionId={section.id}
                            title={section.title}
                            learnMoreHandler={section.learnMoreHandler}
                            tooltip={section.tooltip}
                            cells={section.cells}
                            isFirstSection={index === 0}
                            isLastSection={isLastSection}
                            size={model.size}
                            cellComponent={section.component}
                            renderOnError={section.renderOnError}
                            endCardContent={model.endCardContent}
                        />
                    );
                } else if (section.type === "collective") {
                    return (
                        <QuoteTablePanel
                            key={section.id}
                            panel={section}
                            size={model.size}
                            isFirstSection={index === 0}
                            isLastSection={isLastSection}
                            isAccordion={hasMultipleCollectiveSections}
                            endCardContent={model.endCardContent}
                        />
                    );
                }
            })}
        </React.Fragment>
    );
};

export default React.memo(QuoteTable);
